import * as React from 'react';

import { Props } from './types';
import { arePropsEqual } from './utils';

const AccountLi = React.memo(
  ({ className }: Props) => (
    <svg
      data-testid="account-li-icon"
      className={className}
      width="8"
      height="8"
      viewBox="0 0 8 8"
    >
      <path d="M6.84799139,5.57156581 L6.84643315,5.57156581 C5.90525668,5.26225533 5.48920681,4.914768 5.48920681,4.23615483 C5.48920681,3.82867528 5.80397113,3.97904536 5.94109618,3.23420703 C5.99797191,2.92489655 6.2761176,3.23810263 6.32909774,2.53299939 C6.32909774,2.25017898 6.17716942,2.18395382 6.17716942,2.18395382 C6.17716942,2.18395382 6.25508137,1.76946219 6.28468792,1.44924404 C6.32130654,1.04877657 6.05406852,0.0172222222 4.62516318,0.0172222222 C3.19937432,0.0172222222 2.9321363,1.05033481 2.96875492,1.45080228 C2.99991971,1.77024131 3.07627343,2.18784941 3.07627343,2.18784941 C3.07627343,2.18784941 2.92434511,2.25797018 2.92434511,2.54001147 C2.97732524,3.24589382 3.25547093,2.94125806 3.31234666,3.25134766 C3.45025083,3.99930247 3.76423603,3.8652939 3.76423603,4.27199433 C3.76423603,4.95138662 3.41363221,5.26926741 2.38519435,5.64324482 C1.35208176,6.0203387 0.659444444,6.40522378 0.659444444,6.66700796 L0.659444444,7.45391876 L8.65944444,7.45391876 L8.65944444,6.66700796 C8.65944444,6.40522378 8.02056638,6.01878046 6.84565403,5.57000757 L6.84799139,5.57156581 Z" />
    </svg>
  ),
  arePropsEqual
);

export default AccountLi;
